export default {
    "af": "Afrikaans",
    "ar": "Arabic",
    "be": "Belarusian",
    "ca": "Catalan",
    "cs": "Czech",
    "da": "Danish",
    "de": "German",
    "el": "Greek",
    "es": "Spanish",
    "fi": "Finnish",
    "fr": "French",
    "iw": "Hebrew",
    "hu": "Hungarian",
    "it": "Italian",
    "ja": "Japanese",
    "ko": "Korean",
    "nl": "Dutch",
    "no": "Norwegian",
    "pl": "Polish",
    "pt": "Portuguese",
    "pt-rBR": "Portuguese (Brazilian)",
    "ro": "Romanian",
    "ru": "Russian",
    "sv": "Swedish",
    "sr": "Serbian (Cyrillic)",
    "th": "Thai",
    "tr": "Turkish",
    "uk": "Ukrainian",
    "vi": "Vietnamese",
    "zh": "Chinese Simplified",
    "zh-rTW": "Chinese Traditional",
    "zh-rHK": "Chinese Traditional, Hong Kong",
    "bn": "Bengali",
    "gl": "Galician",
    "hi": "Hindi",
    "lt": "Lithuanian",
    "si": "Sinhala",
    "sk": "Slovak",
    "sl": "Slovenian",
    "te": "Telugu",
    "hr": "Croatian",
    "en-rGB": "English (UK)",
    "bg": "Bulgarian",
    "fa": "Persian",
    "id": "Indonesian",
    "ml": "Malayalam",
    "is": "Icelandic"
}
